import type { PowerUnit } from '../enums'
import type CatalogProduct from './CatalogProduct'
import type Company from './Company'
import type Device from './Device'

export enum PowerSource {
  DIESEL = 'diesel',
  GASOLINE = 'gasoline',
  GAS = 'gas'
}

export type GeneratorAdditionalLoadUnit = PowerUnit.KILOWATT | PowerUnit.AMPERE

export enum LoadAutomationMode {
  MANUAL = 'manual',
  CLOUD = 'cloud',
  LOCAL = 'local'
}

export type Generator = {
  id: string
  powerSource: PowerSource
  apparentPower: number
  nominalVoltage: number
  nominalCurrent: number | null
  serialNumber: string | null
  customerReference: string | null
  customData: object
  relayOnThreshold: number | null
  relayOffThreshold: number | null
  additionalLoad: number
  additionalLoadUnit: GeneratorAdditionalLoadUnit
  relayOffDelay: number
  relayOnDelay: number
  loadAutomationMode: LoadAutomationMode
  device?: Device | null
  deviceName?: string | null
  catalogProduct?: CatalogProduct | null
  catalogProductId: string | null
  company?: Company | null
  companyId: number | null
  createdAt: string
  updatedAt: string
}

export default Generator
